import { Button, Col } from 'react-bootstrap';
import { CustomAutocomplete } from '../../../../shared/components/Autocomplete';
import { AiFillCloseCircle } from 'react-icons/ai';
import React, { useEffect, useState } from 'react';
import { CampaignService } from '../service';
import { ErrorToast } from '../../../../utils/toasters';
import { Campaign } from '../../../../model/campaign/Campaign';
import { InternalRoutes } from '../../../../enum/InternalRoutes';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface ICampaignChangeCampaignMobileProps {
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

export function CampaignChangeMobile({ setShow }: ICampaignChangeCampaignMobileProps) {
    const [campaigns, setCampaigns] = useState<Campaign[]>([]);
    const [selectedCampaignId, setSelectedCampaignId] = useState(0);
    const [filterParams, setFilterParams] = useState({
        page: 1,
        perPage: 10,
        title: '',
    });
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        CampaignService.getCampaigns(filterParams)
            .then(data => {
                setCampaigns(data.data);
            })
            .catch(error => ErrorToast(error));
    }, [JSON.stringify(filterParams)]);

    const changeCampaignHandler = (paramKey: string, paramValue: string | string[] | number) => {
        setSelectedCampaignId(paramValue as number);
    };

    function openCampaignDashboard() {
        if (selectedCampaignId > 0) {
            navigate(`${InternalRoutes.BRAND_CAMPAIGN}/dashboard/${selectedCampaignId}`);
        }
        setFilterParams({ ...filterParams, title: '' });
        setShow(prevState => !prevState);
    }

    return (
        <div className="change-campaign">
            <div className="row align-items-center position-relative justify-content-between default-border-lighter default-radius bg-white p-2 ">
                <Col xs={12} className="p-0 mb-2">
                    <CustomAutocomplete
                        dataArray={campaigns}
                        isWithImage={false}
                        inputLabel="title"
                        changeEventKey="title"
                        setFilterState={setFilterParams}
                        queryFilterKey="title"
                        inputLabelTranslation={t('general.changeCampaign')}
                        handleChangeParams={changeCampaignHandler}
                    />
                </Col>
                <Col className="p-0" md={3}>
                    <Button className="w-100" onClick={() => openCampaignDashboard()} size="sm">
                        Change
                    </Button>
                </Col>
                <AiFillCloseCircle className="closeIcon" onClick={() => setShow(false)} />
            </div>
        </div>
    );
}
